import { t } from "ttag";

import doctorImage from "@/assets/onboarding/doctor.webp";
import vialImage from "@/assets/onboarding/vial.webp";
import weightLossWarrantyImage from "@/assets/onboarding/weight-loss-guarantee.webp";
import { Heading } from "@/shared/ui";

export const WhatsIncluded = () => (
  <section className="flex flex-col gap-4 rounded-2xl bg-secondary-50 p-5">
    <Heading
      level={2}
      color="primary"
      size="large"
      align="center"
      weight="medium"
    >
      {t`What is included?`}
    </Heading>

    <Item
      img={vialImage}
      title={t`Prescription to Fast and Effective GLP-1`}
      subtitle={t`(Cost of medication is included)`}
    />

    <Item img={doctorImage} title={t`1:1 Physician Guidance`} />

    <Item img={weightLossWarrantyImage} title={t`Weight Loss Guarantee`} />

    <p className="text-secondary-500">{t`+ 24/7 support and free shipping!`}</p>
  </section>
);

interface ItemProps {
  img: string;
  title: string;
  subtitle?: string;
}
const Item = ({ img, title, subtitle }: ItemProps) => (
  <div className="flex items-center gap-4 text-lg text-primary-950">
    <img
      alt={title}
      src={img}
      className="size-20 shrink-0 rounded-sm bg-secondary-100 object-contain"
    />

    <div className="flex flex-col">
      <p className="font-medium">{title}</p>

      {subtitle && <p>{subtitle}</p>}
    </div>
  </div>
);
